import React, { useMemo, useState } from 'react';
import { Checkbox } from 'antd';
import { MainTitle } from '../../../../../common/index.jsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  CreditCardOutlined,
  FilterOutlined,
  ReloadOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';

const NewsFilter = ({
  selectedCategories,
  onCategoriesChange,
  onClickShowArchive,
  onRefetch = () => undefined,
  categories,
}) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth?.user);

  const [areFiltersVisible, setAreFiltersVisible] = useState(false);
  const filterIsActive = selectedCategories?.length > 0 || false;

  const checkboxOptions = useMemo(
    () =>
      categories.map(({ name, id }) => ({
        value: String(id),
        label: name,
      })),
    [categories],
  );

  return (
    <div className="hp-filters-container">
      <MainTitle
        title={t('Aktuality')}
        actions={[
          ...(user
            ? [
                {
                  onClick: () => {
                    window.location.href = '/cms/news/create';
                  },
                  title: t('Pridať novú aktualitu'),
                  icon: <PlusOutlined />,
                },
              ]
            : []),
          {
            onClick: onRefetch,
            title: t('Obnoviť'),
            icon: <ReloadOutlined />,
          },
          {
            title: t(
              filterIsActive ? 'Filter aktualít (aktívny)' : 'Filter aktualít',
            ),
            icon: <FilterOutlined />,
            onClick: () => setAreFiltersVisible((v) => !v),
            style: filterIsActive
              ? { backgroundColor: '#15489e', color: 'white' }
              : {},
          },
          {
            onClick: () => onClickShowArchive(),
            title: t('Archív'),
            icon: <CreditCardOutlined />,
          },
        ]}
      />

      <div
        className={`main-shadow form-inline lg-mb-10 xs-mb-5 xs-p-10 filter-wrapper`}
        style={{
          display: areFiltersVisible ? 'block' : 'none',
        }}
      >
        <Checkbox.Group
          style={{ width: '100%' }}
          name="filters"
          onChange={onCategoriesChange}
          options={checkboxOptions}
          value={selectedCategories}
        />
      </div>
    </div>
  );
};

export default NewsFilter;

NewsFilter.propTypes = {
  categories: PropTypes.array,
  onCategoriesChange: PropTypes.func,
  onRefetch: PropTypes.func,
  selectedCategories: PropTypes.array,
  onClickShowArchive: PropTypes.func,
};
